import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import EmotionScoreTooltipImg from "@/assets/report-assets/emotion-score-tooltip.png";

/*
 * EmotionScoreTitleInfoModal component
 *
 * This modal displays information about the Emotion score and its scale.
 */
export const EmotionScoreInfoModal = () => {
  /* Hooks */
  const { close } = useModalStore((state) => state.modalActions);

  /* Render */
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2>Emotion score</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0" />
      </div>

      {/* Emotion score tooltip image */}
      <div className="flex items-center justify-center">
        <img src={EmotionScoreTooltipImg} alt="Emotion score visualization" className="w-full max-w-lg rounded-lg" />
      </div>

      {/* Description */}
      <p className="text-center">
        Emotion score measures the intensity of an emotional response (this can be a positive or negative response) towards an asset and is derived from multiple factors such as
        visuals, text, attention and visibility.
      </p>

      {/* Gradient Scale */}
      <div className="flex flex-col gap-4">
        {/* Gradient Bar with Labels */}
        <div className="flex items-center gap-4">
          <span className="text-xl font-bold">0%</span>
          <div className="flex-1 h-4 rounded-full" style={{ background: "linear-gradient(to right, #ef4444, #f97316, #eab308, #84cc16, #22c55e, #10b981)" }}></div>
          <span className="text-xl font-bold">100%</span>
        </div>

        {/* Scale Labels */}
        <div className="flex items-start justify-between gap-20 mt-2">
          <div className="flex-1 text-left max-w-32">
            <p className="font-medium text-base text-center">Low emotional intensity</p>
          </div>
          <div className="flex-1 text-right max-w-32">
            <p className="font-medium text-base text-center">High emotional intensity</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <p className="text-center text-xs text-base-content/60 px-10">
        Scores are based on Dragonfly Emotion Model which was trained on 118k images and tested with 1200 individuals.
      </p>
    </div>
  );
};
